import { useMemo } from 'react';
import useOrganizationConfig from '@/api/core/organization-config/useOrganizationConfig';
import { ProductModule } from '@erp/shared-types';

// Re-export ProductModule from shared types
export { ProductModule };

export type ModuleEnabledFunction = (moduleName: ProductModule) => boolean;

export function useIsModuleEnabled() {
  const { data, isLoading, error } = useOrganizationConfig();

  const enabledModules: Set<string> = useMemo(() => {
    if (!data?.organizationConfig?.enabledModules) return new Set();
    return new Set(data.organizationConfig.enabledModules);
  }, [data?.organizationConfig?.enabledModules]);

  const isModuleEnabled: ModuleEnabledFunction = (moduleName) => {
    return enabledModules.has(moduleName);
  };

  return {
    isModuleEnabled,
    isLoading,
    error,
  };
}
